import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { updateCurrentBoard, getReports } from './interactive-header.state';

export const withInteractiveHeaderData = connect(
    state => ({
        currentBoard: state.navigation.interactiveHeader.currentBoard,
        boards: state.navigation.interactiveHeader.boards,
        loadingState: state.navigation.interactiveHeader.loadingState,
        objectSelected: state.data.objectSelected,
    }),
    dispatch => bindActionCreators({
        updateCurrentBoard,
        getReports,
    }, dispatch),
);
